<template>
    <section class="container hidden-first">
        <div class="row-custom">
            <div class="about-col">
                <h1>Het team</h1>
                <p class="par-spacing">
                    Ons team bestaat uit twee ervaren tandartsen, drie mondhygiënisten, een preventieassistente en een assistent die met zorg en aandacht werken aan een gezond en stralend gebit. Wij nemen de tijd om naar uw wensen te luisteren en zorgen voor een persoonlijke benadering, of het nu gaat om een controle, gebitsreiniging of uitgebreide behandeling.
                </p>
                <p class="par-spacing">
                    We blijven up-to-date met de nieuwste ontwikkelingen in de tandheelkunde. Dankzij regelmatige bijscholing en het gebruik van moderne technieken kunnen wij u altijd de meest effectieve en comfortabele behandelingen bieden.
                </p>
                <p class="par-spacing">
                    Samen zorgen we voor een optimale mondgezondheid, zodat u met vertrouwen kunt blijven glimlachen.
                </p>
                <!-- <a href="" class="hero-btn red-btn">Steun ons</a> -->
            </div>
            <div class="about-col image-col-right">
                <img src="../assets/images/milmir.jpg" id="the-practice-img">
                <!-- <i class="fa-solid fa-question"></i> -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
name: "TheTeamInfo",
mounted(){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Home - Tandzorg Gestel"
      // document.querySelector('meta[name="description"]').setAttribute("content", "Home pagina website milad.");
      
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show-first {
  opacity: 1;
  transform: translateX(0);
}
.about-col {
    flex-basis: 48%;
    /* padding: 30px 2px; */
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}
.about-col img {
    width: 100%;
    max-width: 600px;
}
.about-col h1 {
    padding-top: 0;
}
.about-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}
.par-spacing {
    margin-bottom: -5px;
}

@media(max-width: 978px) {
    .about-col {
        flex-basis: 48%;
        /* padding: 10px 2px; */
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }
    h3 {
        font-size: 16px;
    }

    .about-col img {
        max-width: 100%;
    }

    .about-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
        margin-top: 25px;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0,0,0,0.12);
    }

}
</style>